mutation CreateMultiplePromocodes($input: CreateMultiplePromocodesInput!) {
  createMultiplePromocodes(input: $input) {
    id
    title
    promocodeCampaign {
      id
      title
    }
    createdAt
    updatedAt
  }
}
